// extracted by mini-css-extract-plugin
export default {"container":"DataTable_container__Wr8mO","wrapper":"DataTable_wrapper__P0tQs","dataCell":"DataTable_dataCell__G9S21","row":"DataTable_row__KQSM4"};